import { RootState } from "@src/store";
import { getVariationDraft } from "@src/store/slices/experienceBuilder/basicMod/selectors/getVariationDraft";

export function getVariationDraftLayout(state: RootState) {
  const mod = getVariationDraft(state);
  return mod?.type === "layout" ? mod : undefined;
}
